<template>
  <div>
    <h2>{{ $t('eventDashboard.list.mainTitle') }}</h2>
    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>
    <div class="mt-4 mb-12">
      <h5>Quicklinks</h5>
      <div><a href="https://www.dropbox.com/s/2b3xp4kxvtk4pob/Company%20handbook.docx?dl=0" target="_blank">Venturelab Handbook</a></div>
      <div><a href="https://www.dropbox.com/s/81y56le8rgiywag/Venturelab%20Master%20Cockpit.xlsx?dl=0" target="_blank">Cockpit</a></div>
      <div v-for="link in quicklinks" :key="link.field_001">
        <a :href="link.url" target="_blank">{{ link.name }}</a>
      </div>
      <v-btn
        outlined
        color="secondary"
        small
        class="btn-mg btn-cstm-sm mt-3"
        @click="openAddQuickLinkModal"
      >Add Quicklink</v-btn>
    </div>
    <h5>My upcoming events</h5>
    <dx-data-grid
      id="eventDashboardContainer"
      :data-source="dashboardevents"
      :allow-column-reordering="false"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
      :show-borders="true"
      :showColumnLines="true"
      :showRowLines="true"
      key-expr="eventId"
      no-data-text="Add Events to your Dashboard"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      :hover-state-enabled="true"
    >

      <dx-scrolling mode="virtual"/>

      <dx-search-panel
        :visible="true"
        :width="320"
        placeholder="Search..."
      />

      <dx-column
        data-field="eventId"
        :caption="$t('eventDashboard.list.id')"
      />
      <dx-column
        data-field="crmEvent.eventlisttitleEN"
        :caption="$t('eventDashboard.list.eventname')"
        cell-template="eventtitle-template"
      />
      <dx-column
        data-field="crmEvent.course_no"
        :caption="$t('eventDashboard.list.courseNo')"
      />
      <dx-column
        data-field="crmEvent.vlabApplicationDeadline"
        :caption="$t('eventDashboard.list.deadline')"
        data-type="date"
        format="dd.MM.yyyy"
        alignment="right"
        :width="150"
        sort-order="asc"
      />
      <dx-column
        data-field="crmEvent.sortierdatum"
        :caption="$t('eventDashboard.list.date')"
        data-type="date"
        format="dd.MM.yyyy"
        alignment="right"
        :width="150"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.field_001"
        :caption="$t('eventDashboard.list.registration')"
        cell-template="registrations-template"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen"
        :caption="$t('eventDashboard.list.docSubmitted')"
        cell-template="doc-submitted-template"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.eventSignupAffirmIDId"
        :caption="$t('eventDashboard.list.confirmed')"
        cell-template="confirmed-template"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.cRMAddress.salutationId"
        :caption="$t('eventDashboard.list.female')"
        :calculate-cell-value="calculateFemale"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.cRMAddress.kantonId"
        :caption="$t('eventDashboard.list.romandie')"
        :calculate-cell-value="calculateRomandie"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.cRMAddress.unispinoffId"
        :caption="$t('eventDashboard.list.epfl')"
        :calculate-cell-value="calculateEPFL"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.cRMAddress"
        :caption="$t('eventDashboard.list.eth')"
        :calculate-cell-value="calculateETH"
      />
      <dx-column
        data-field="crmEvent.cRMAnmeldungBestellungen.cRMAddress.cRMAdresseJOINRolles"
        :caption="$t('eventDashboard.list.vk')"
        :calculate-cell-value="calculateVK"
      />
      <dx-column
        caption=""
        cell-template="button-template"
        type="buttons"
        :width="80"
      />
      <template #eventtitle-template="{ data }">
        <a v-if="data.data.eventId" :href="`/seminar/${data.data.eventId}`" target="_blank">
          <div>
            {{data.data.crmEvent.eventlisttitleEN ? data.data.crmEvent.eventlisttitleEN : (data.data.crmEvent.eventlisttitleDE ? data.data.crmEvent.eventlisttitleDE : (data.data.crmEvent.eventpool.thema_en ? data.data.crmEvent.eventpool.thema_en : ''))}}
          </div>
        </a>
        <div v-else>
          {{data.data.crmEvent.eventlisttitleEN ? data.data.crmEvent.eventlisttitleEN : (data.data.crmEvent.eventlisttitleDE ? data.data.crmEvent.eventlisttitleDE : (data.data.crmEvent.eventpool.thema_en ? data.data.crmEvent.eventpool.thema_en : ''))}}
        </div>
      </template>
      <template #button-template="{ data }">
        <div>
          <a v-if="data.data.crmEvent.event_art_id === '2'" :href="`https://crm.ifj.ch/index.cfm?&page=124441&detail_id=${data.data.eventId}`" target="_blank"><i class="fas fa-pen mr-3"></i></a>
          <a v-else :href="`https://crm.ifj.ch/index.cfm?&page=116990&detail_id=${data.data.eventId}`" target="_blank"><i class="fas fa-pen mr-3"></i></a>
          <a @click="removeEvent(data)"><i class="fas fa-times removeBtn"></i></a>
        </div>
      </template>
      <template #registrations-template="{ data }">
        <b-button
          size="sm"
          :variant="calculateRegistrations(data).variant"
        >
          {{calculateRegistrations(data).count}}
        </b-button>
      </template>
      <template #doc-submitted-template="{ data }">
        <b-button
          size="sm"
          :variant="calculateConfirmedOrDocSubmitted(data, false)"
        >
          {{ countConfirmedRegistrations(data, affirmationDocSubmittedId) }}
        </b-button>
      </template>
      <template #confirmed-template="{ data }">
        <b-button
          size="sm"
          :variant="calculateConfirmedOrDocSubmitted(data, true)"
        >
          {{ countConfirmedRegistrations(data, affirmationConfirmedId) }}
        </b-button>
      </template>
      <dx-toolbar>
        <dx-item
          name="searchPanel"
        />
        <dx-item
          location="after"
          template="addToDashboard"
        />
      </dx-toolbar>
      <template #addToDashboard>
        <v-btn
          color="primary"
          class="btn-mg btn-cstm-sm"
          @click="openAddToDashboardModal"
        >Add / Edit Event</v-btn>
      </template>
      <dx-summary>
        <dx-total-item
          column="event"
          summary-type="count"
        />
      </dx-summary>
    </dx-data-grid>
    <b-modal
      v-model="modalRemoveAlert"
      centered
      size="sm"
      button-size="sm"
      no-close-on-backdrop
      title="Remove Event"
      @show="resetModal"
      @hidden="resetModal"
      @ok="removeEventFromDashboard"
      cancelTitle="No"
      okTitle="Yes"
    >Do you really want to remove the event?
    </b-modal>
    <add-event-modal ref="addEventModalRef" @added-event="getDashboardevents"/>
    <add-quick-link-modal ref="addQuicklinkModalRef" @added-quicklink="getQuicklinks"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import moment from 'moment'
  import addEventModal from '@/components/eventDashboard/AddEventModal.vue'
  import addQuickLinkModal from '@/components/eventDashboard/AddQuickLinkModal.vue'
  // import DxButton from 'devextreme-vue/button'
  import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSearchPanel,
    DxSummary,
    DxTotalItem,
    DxItem,
    DxToolbar
  } from 'devextreme-vue/data-grid'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxScrolling,
      DxSearchPanel,
      DxSummary,
      DxTotalItem,
      DxItem,
      // DxButton,
      DxToolbar,
      addEventModal,
      addQuickLinkModal
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        modalRemoveAlert: false,
        itemToRemove: null,
        affirmationConfirmedId: 4,
        affirmationDocSubmittedId: 13,
        excludedAffirmations: [6, 11] // 6 = cancelled, 11 = refused
      }
    },
    /* mounted () {
      this.$root.$on('refresh-documents', () => {
        this.getHistory()
      })
    }, */
    created () {
      // this.getEvents()
      // this.registerUserManually()
      this.getQuicklinks()
      this.getDashboardevents()
    },
    methods: {
      openAddToDashboardModal () {
        this.$refs.addEventModalRef.openModal()
      },
      openAddQuickLinkModal () {
        this.$refs.addQuicklinkModalRef.openModal()
      },
      resetModal () {
        this.modalRemoveAlert = false
      },
      removeEvent (data) {
        this.modalRemoveAlert = true
        this.itemToRemove = data.data.field_001
      },
      countConfirmedRegistrations (data, affirmationId) {
        const registrations = data.data.crmEvent.cRMAnmeldungBestellungen.reduce((count, order) => {
          if (order.eventSignupAffirmIDId === affirmationId) {
            return count + 1
          }
          return count
        }, 0)

        return registrations
      },
      calculateFemale (rowData) {
        const femaleSalutationIds = [1, 3, 5, 7, 9, 11, 13, 15, 48, 49, 50, 54, 55, 56, 60, 61, 62, 66, 67, 68]
        const female = rowData.crmEvent.cRMAnmeldungBestellungen.reduce((count, order) => {
          if (order.cRMAddress && femaleSalutationIds.includes(order.cRMAddress.salutationId) && !this.excludedAffirmations.includes(order.eventSignupAffirmIDId)) {
            return count + 1
          }
          return count
        }, 0)

        return female
      },
      calculateRomandie (rowData) {
        const romandieIds = [10, 22, 23, 24, 25, 26]
        const romandie = rowData.crmEvent.cRMAnmeldungBestellungen.reduce((count, order) => {
          if (order.cRMAddress && romandieIds.includes(order.cRMAddress.kantonId) && !this.excludedAffirmations.includes(order.eventSignupAffirmIDId)) {
            return count + 1
          }
          return count
        }, 0)

        return romandie
      },
      calculateEPFL (rowData) {
        return this.calculateUniversity(rowData, 1)
      },
      calculateETH (rowData) {
        return this.calculateUniversity(rowData, 2)
      },
      calculateUniversity (rowData, universityId) {
        const uni = rowData.crmEvent.cRMAnmeldungBestellungen.reduce((count, order) => {
          if (order.cRMAddress && order.cRMAddress.unispinoffId === universityId && !this.excludedAffirmations.includes(order.eventSignupAffirmIDId)) {
            return count + 1
          }
          return count
        }, 0)

        return uni
      },
      calculateVK (rowData) {
        return rowData.crmEvent.cRMAnmeldungBestellungen.reduce((count, order) => {
          if (
            !this.excludedAffirmations.includes(order.eventSignupAffirmIDId) &&
            order.cRMAddress &&
            order.cRMAddress.cRMAdresseJOINRolles.some(role => role.rolle_id === 99)
          ) {
            return count + 1
          }
          return count
        }, 0)
      },
      calculateRegistrations (data) {
        const registrationsRaw = data.data.crmEvent.cRMAnmeldungBestellungen

        const validRegistrationsCount = registrationsRaw.filter(
          (r) => !this.excludedAffirmations.includes(r.eventSignupAffirmIDId)
        ).length

        const minRegistrations = data.data.crmEvent.min_registrations
        const percent = minRegistrations > 0 ? (100 * validRegistrationsCount) / minRegistrations : 0

        return {
          count: validRegistrationsCount,
          variant: minRegistrations ? this.getPillVariant(percent) : 'secondary'
        }
      },
      calculateConfirmedOrDocSubmitted (data, minConfirmedField) {
        const registrations = this.countConfirmedRegistrations(data, minConfirmedField ? this.affirmationConfirmedId : this.affirmationDocSubmittedId)
        const dataField = minConfirmedField ? data.data.crmEvent.min_confirmed : data.data.crmEvent.min_doc_submitted
        const procent = (100 * registrations) / dataField
        return dataField ? this.getPillVariant(procent) : 'secondary'
      },
      getPillVariant (procent) {
        if (procent >= 100) {
          return 'success'
        } else if (procent >= 85) {
          return 'warning'
        } else {
          return 'danger'
        }
      },
      async getQuicklinks () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('eventDashboard/GET_QUICKLINKS')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async getDashboardevents () {
        this.$Progress.start()
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('eventDashboard/GET_DASHBOARDEVENTS')
          if (errors) throw errors
          this.$Progress.finish()
        } catch (err) {
          this.$Progress.fail()
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async removeEventFromDashboard () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('eventDashboard/DELETE_OWNER', this.itemToRemove)
          if (errors) throw errors
          this.getDashboardevents()
          this.itemToRemove = null
          setTimeout(() => {
            this.success = false
          }, 3000)
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      }
    },
    computed: {
      ...mapGetters({
        quicklinks: 'eventDashboard/QUICKLINKS',
        dashboardevents: 'eventDashboard/DASHBOARDEVENTS'
      })
    }
  }
</script>
<style lang="scss">
.removeBtn {
  cursor: pointer;
  color: #337ab7;
}

.btn-cstm-sm {
  font-size: 12px;
}

.btn-cstm-sm .dx-button-content {
  padding: 4px 6px;
}
</style>
